import React, {
  useContext,
  useEffect,
  useState
}                          from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import Request             from '~/providers/Request';
import {
  showPerson
}                          from '~/config/routes';
import PersonRecord        from '~/records/PersonRecord';
import Context             from './context';
import isBlank             from '~/utils/isBlank';
import Form                from './Form';

const getInitialUserRecord = (records, id) => {
  let attrs = {id};
  if(records && records[id]){ attrs = records[id]; }
  return new PersonRecord(attrs);
};

function EditPerson({history}) {

  const { id } = history.location.route.getParams();
  const { records } = useContext(Context);
  const [ record, setRecord] = useState( getInitialUserRecord(records, id) );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if( isBlank(records) ){ setLoading(true); }
    Request.get(`/admin/users/${id}`, {})
      .then( response => {
        setLoading(false);
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function onSubmit (){
    const data = record.toParams();
    Request.put(`/admin/users/${id}`, data, {}, { controller: 'person' })
      .then(async (resp) => {
        const data = resp.data;
        const imageBase64 = record.get('image_base64');

        setLoading(true);

        if(imageBase64){
          try {
            const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}`, user_id: data.id});
            console.log('upload Image', result);
          } catch(e) {console.log(e);}
        }

        setLoading(false);
        history.push(showPerson.reverse(resp.data));
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return (
    <Form
      loading={loading}
      record={record}
      handleChange={handleChange}
      setRecord={setRecord}
      onSubmit={onSubmit}
      title='editPerson'
    />
  );
}

EditPerson.propTypes={
  history: historyPropType,
};

export default (EditPerson);
